import MarqueeLib from 'react-fast-marquee';
import { useGetNotificationsQuery } from '@/store/api/contentApi';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { toggleLiveTv } from '@/store/slices/uiSlice';
import { showToast } from '@/utils';
import { Icons } from '@/utils/Icons';

const Marquee = ({ type }: { type?: string }) => {
  const { data } = useGetNotificationsQuery({ type: 'Alert' });
  const dispatch = useAppDispatch();
  const liveTvEnabled = useAppSelector((state) => state.ui.liveTvEnabled);
  const hasLiveTvUrl = useAppSelector((state) => Boolean(state.media.liveTvUrl));
  const activeAlerts =
    data?.data?.Alert?.filter((item) => item.isActive).map((item) => item.body) || [];
  const alerts = activeAlerts.length
    ? activeAlerts
    : [
        '🎰🔥 The casino floor is buzzing with excitement! 🃏 Teen Patti • ♦️ Baccarat • ♣️ Poker 💸 Play Live. Win Big. Celebrate Bigger',
      ];

  const content = (
    <MarqueeLib speed={60} gradient={false} pauseOnHover>
      {alerts.map((text, index) => (
        <span key={index} className="mr-6 flex items-center">
          {text}
          {index !== alerts.length - 1 && <span className="mx-3">|</span>}
        </span>
      ))}
    </MarqueeLib>
  );

  if (type === 'mobile') {
    return (
      <div className="relative flex flex-1 overflow-hidden whitespace-nowrap bg-white text-sm italic text-black">
        {/* Speaker */}
        <div className="z-20 flex shrink-0 items-center bg-secondary-dark p-1.5 text-white">
          <Icons.speaker />
        </div>

        {/* Marquee */}
        <div className="min-w-0 flex-1 pr-12 ">{content}</div>
        {/* TV Icon - toggles live TV mode on mobile */}
        {/* {gameDetails && ( */}

        <button
          type="button"
          onClick={() => {
            if (!hasLiveTvUrl) {
              showToast('Live TV not available', 'error');
              return;
            }
            dispatch(toggleLiveTv());
          }}
          className={`md:hidden absolute right-0 top-0 z-30 flex h-full items-center px-2 shadow-md transition-colors ${
            liveTvEnabled ? 'bg-primary text-white' : 'bg-yellow-400 text-black'
          }`}
          aria-label="Toggle live TV"
        >
          <Icons.Tv />
        </button>
        {/* )} */}
      </div>
    );
  }

  return (
    <div
      style={{ lineHeight: 'normal' }}
      className="absolute flex w-1/2 whitespace-nowrap text-sm italic text-white"
    >
      {content}
    </div>
  );
};

export default Marquee;
